import { Directive, DirectiveBinding } from 'vue';
import i18n from '../i18n';

function addressFormatter(el: HTMLElement, { value, arg }: DirectiveBinding<any>) {
   if (!value) return (el.innerHTML = '');
   const box = value.box ? `${i18n.global.t('generic.addresses.box')}: ${value.box}` : '';

   if (!value?.street && !value?.house_number && !value?.box && !value?.city?.postal_code && !value?.city?.name)
      return (el.innerHTML = '-');
   if (!value?.street && !value?.house_number && !value?.box && value.city?.postal_code && value.city?.name)
      return (el.innerHTML = `${value?.city?.postal_code || ''} ${value?.city?.name || ''}`);
   el.innerHTML = `${value?.street || ''} ${value?.house_number || ''} ${box} ${arg === 'wrap' && value.street ? '<br>' : ''}${
      value?.city?.postal_code || ''
   } ${value?.city?.name || ''}`;
}

const AddressFormatter: Directive = {
   mounted: addressFormatter,
   updated: addressFormatter,
};

export { AddressFormatter };
